module.exports = __webpack_public_path__ + "img/small.25367689.png";